import React from 'react'
import { MetricCard } from '@/components/MetricCard'
import { Users, UserCheck, TrendingUp, Network } from 'lucide-react'

interface TeamMetricsProps {
  directReportsCount: number
  totalTeamSize: number
  spanOfControl: number
  avgTenure?: number
}

export function TeamMetrics({
  directReportsCount,
  totalTeamSize,
  spanOfControl,
  avgTenure
}: TeamMetricsProps) {
  return (
    <div className="dashboard-grid lg:grid-cols-4">
      <MetricCard
        title="Subordinados Diretos"
        value={directReportsCount}
        icon={UserCheck}
        trend="neutral"
      />
      <MetricCard
        title="Tamanho Total da Equipe"
        value={totalTeamSize}
        icon={Users}
        trend="neutral"
      />
      <MetricCard
        title="Alcance de Controle"
        value={spanOfControl}
        icon={Network}
        trend={spanOfControl > 7 ? 'down' : 'neutral'}
        change={spanOfControl > 7 ? 'Alto' : 'Ideal'}
      />
      {avgTenure !== undefined && !isNaN(avgTenure) && avgTenure > 0 && (
        <MetricCard
          title="Tempo Médio na Equipe"
          value={`${avgTenure.toFixed(1)} anos`}
          icon={TrendingUp}
          trend="up"
        />
      )}
    </div>
  )
}
